// extracted by mini-css-extract-plugin
export default {"employee-header":"Header_employee-header__3B+F1","employee-header__buttons":"Header_employee-header__buttons__RsPEW","employee-header-item":"Header_employee-header-item__80Dhf"};